(() => {
  if (customElements.get('slider-testimonials')) {
    return;
  }

  class SliderTestimonials extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.swiper')) return;

      this.options = {
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          990: {
            spaceBetween: 32,
            slidesPerGroup: 2,
            slidesPerView: 2,
          },
          1200: {
            slidesPerGroup: 4,
            slidesPerView: 4,
          },
        },
      };
      this.slider = new Swiper(this.querySelector('.swiper'), this.options);
    }
  }

  customElements.define('slider-testimonials', SliderTestimonials);
})();
